import { Link, useParams } from 'react-router-dom'

export function NotFoundPage() {
  const { slug } = useParams<{ slug: string }>()
  return (
    <div className="container-page flex min-h-[60vh] flex-col items-center justify-center gap-3 text-center">
      <p className="font-body text-label-caps uppercase text-on-surface-variant">404</p>
      <h1 className="font-display text-headline-md text-on-surface">Page not found</h1>
      {slug && (
        <Link to={`/${slug}`} className="text-body-md text-primary underline underline-offset-4">
          Back to the salon home page
        </Link>
      )}
    </div>
  )
}
